import { getOrCreateUserId as getOrCreateUserGuid } from './userUtils';

const REACT_APP_SERVER_URL = process.env.REACT_APP_SERVER_URL

const fetchWithUserGuidHeader = (url, params) => {
    const new_params = { ...params };
    new_params.headers = {
        ...new_params.headers,
        'X-User-Guid': getOrCreateUserGuid(),
    };

    return fetch(`${REACT_APP_SERVER_URL}${url}`, new_params);
};

export const fetchProductList = async (id) => {
    const res = await fetchWithUserGuidHeader(`/api/lists/${id}`);
    if (!res.ok) {
        throw new Error('Failed to fetch the product list');
    }
    return await res.json();
};

export const deleteProductFromList = (listId, productId) => {
    return fetchWithUserGuidHeader(`/api/lists/${listId}/products/${productId}`, { method: 'DELETE' });
};

export const fetchLists = async () => {
    const res = await fetchWithUserGuidHeader(`/api/lists/`);
    if (!res.ok) {
        throw new Error('Failed to fetch user lists');
    }
    return await res.json();
};

export const fetchProductListCandidates = async (listId) => {
    const res = await fetchWithUserGuidHeader(`/api/lists/${listId}/candidates`);
    if (!res.ok) {
        throw new Error('Failed to fetch product list candidates');
    }
    return await res.json();
};

export const deleteList = (listId) => {
    return fetchWithUserGuidHeader(`/api/lists/${listId}`, { method: 'DELETE' });
};

export const createList = async (category) => {
    const res = await fetchWithUserGuidHeader(`/api/lists/category/${category}`, { method: 'POST' });
    if (!res.ok) {
        throw new Error('Failed to create a new list');
    }
    return await res.json();
}

export const likeProduct = async (listId, productId, source) => {
    const res = await fetchWithUserGuidHeader(`/api/lists/${listId}/products/${productId}/like`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ source }),
    });

    if (!res.ok) {
        throw new Error('Failed to like the product');
    }
    return res;
}

export const dislikeProduct = async (listId, productId, source) => {
    const res = await fetchWithUserGuidHeader(`/api/lists/${listId}/products/${productId}/dislike`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ source }),
    });

    if (!res.ok) {
        throw new Error('Failed to like the product');
    }
    return res;
}

export const repopulate = async (listId) => {
    const res = await fetchWithUserGuidHeader(`/api/lists/${listId}/repopulate`, { method: 'POST' });
    if (!res.ok) {
        throw new Error('Failed to repopulate candidates');
    }
    return res;
}

export const voteProduct = async (listId, productId) => {
    const res = await fetchWithUserGuidHeader(`/api/lists/${listId}/products/${productId}/vote`, { method: 'POST' });
    if (!res.ok) {
        throw new Error('Failed to vote the product');
    }
    return res;
}

export const unvoteProduct = async (listId, productId) => {
    const res = await fetchWithUserGuidHeader(`/api/lists/${listId}/products/${productId}/unvote`, { method: 'POST' });
    if (!res.ok) {
        throw new Error('Failed to vote the product');
    }
    return res;
}